<template>
	<div style="position: relative">
		<div class="dashboard-wrapper">
			<div class="dashboard-info-content">
				<h3>{{ turisem_point_of_day.poi_title }}</h3>
				<span v-text="turisem_point_of_day.poi_desc"></span>
			</div>
			<div class="dashboard-content">
				<img
					class="turizmi-bg lazyload"
					@load="hideSplashScreen()"
					:src="turisem_point_of_day.poi_simg_src"
					alt
				/>
			</div>
			<div class="dashboard-items">
				<button
					@click="goToTurisemPointOfTheDay()"
					class="float-button-draggable bounce-1"
				>
					<v-icon color="white">place</v-icon>
				</button>
				<!-- <div class="dashboard-items-top-wrapper">
				<div class="dashboard-item-top dashboard-item-temp">
					<img class="cloudy-img" :src="iconDashboard.temperature" alt />
					<div class="dashboard-item-temp-nr">
					<span>{{temperature_wind.temperature}}</span>
					<span>&#176;C</span>
					</div>
				</div>
				<div class="dashboard-item-top dashboard-item-air">
					<img class="wave-img" :src="iconDashboard.shpejtesiaeres" alt />
					<span>{{temperature_wind.wind_speed}} kmh</span>
				</div>
				<div v-on:click="goTo('/report')" class="dashboard-item-top dashboard-item-notification">
					<span>{{getStateWithParam('new_raport')}}</span>
				</div>
				<router-link
					to="/report/makereport"
					tag="div"
					class="dashboard-item-top dashboard-item-raporto"
				>
					<img class="plus-img" src="@/assets/img/plus.png" alt />
					<span>{{getStateWithParam('report_label')}}</span>
				</router-link>
			</div> -->
				<div class="dashboard-items-bottom-wrapper">
					<div
						v-on:click="goTo('/pay')"
						class="dashboard-item-bottom"
					>
						<img
							class="parking-img"
							src="@/assets/img/parking.png"
							alt
							style="margin-right: 10px"
						/>
						<span style="line-height: 1">{{
							getStateWithParam("parking_pay_label")
						}}</span>
					</div>

					<div
						class="dashboard-item-bottom"
						@click="openNumberToCall()"
					>
						<img
							class="parking-img"
							src="@/assets/img/phone.png"
							alt
							style="margin-right: 10px"
						/>
						<span style="white-space: nowrap">0800 0888</span>
					</div>
					<router-link
						to="/report/makereport"
						tag="div"
						class="dashboard-item-bottom dashboard-item-raporto"
					>
						<img
							class="plus-img"
							src="@/assets/img/plus.png"
							alt
							style="margin-right: 10px"
						/>
						<span>{{ getStateWithParam("report_label") }}</span>
					</router-link>
				</div>
				<div class="dashboard-arrow">
					<v-icon sm color="white" class="bounce-1"
						>keyboard_arrow_up</v-icon
					>
					<span class="swipe-text">Swipe up</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import poi from "@/config/api/api_events/poi.js";
//import air from "@/config/api/api_events/air.js";
import settings from "@/config/api/api_events/settings";
import native_capacitor from "@/config/js_helper/native_capacitor";
import map_helper from "@/config/js_helper/map_helper.js";

export default {
	name: "HomeDashboard",
	data() {
		return {
			iconDashboard: {
				temperature: require("@/assets/img/new_icons/temperature.svg"),
				shpejtesiaeres: require("@/assets/img/new_icons/shpejtesiaeres.svg"),
			},
			temperature_wind: { temperature: 24, wind_speed: 2 },
			turisem_point_of_day: {
				poi_id: "205",
				category_id: "7",
				poi_title: "Muzeu Historik Kombëtar",
				poi_desc:
					"U përurua më 28 tetor 1981 dhe është institucioni muzeor më i madh në Shqipëri. Muzeu Historik zë një sipërfaqe të përgjithëshme prej 27.000 ...",
				poi_bimg_src: "",
				poi_simg_src: require("@/assets/img/muzeu_kombetare.jpg"),
				poi_content: "",
			},
			x_prop: 380,
			y_prop: 200,
		};
	},
	computed: {
		getLangTypeToUse() {
			return this.$store.state.type_language;
		},
	},
	watch: {
		getLangTypeToUse() {
			this.getPointOfTheDay();
		},
	},
	beforeMount() {
		this.getPointOfTheDay();
	},
	methods: {
		hideSplashScreen() {
			this.$store.state.active_loader = false;
		},
		getPointOfTheDay() {
			poi.getPoi(this.getLangTypeToUse, 1)
				.then((response) => {
					if (response != null) {
						var { poi_desc } = response;
						this.turisem_point_of_day = response;

						this.turisem_point_of_day.poi_desc =
							poi_desc.split(" ").splice(0, 20).join(" ") + "...";
					}
					this.$store.state.active_loader = false;
				})
				.catch((err) => {
					this.$store.state.active_loader = false;
				});
		},
		goTo(place) {
			this.$router.push(place);
		},
		openNumberToCall() {
			window.open("tel:08000888", "_system");
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		goToTurisemPointOfTheDay() {
			map_helper.goTurisemDetail(
				parseInt(this.turisem_point_of_day.poi_id),
				false
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.dashboard-wrapper {
	background-color: transparent;
	position: relative;
	height: calc(100vh - 56px - var(--top));
	color: black !important;
	display: flex;
	flex-direction: column;
	.dashboard-info-content {
		padding: 0 15px;
		color: white;
		z-index: 3;
		position: relative;
		width: 100%;
		max-width: 355px;
	}

	.dashboard-content {
		position: fixed;
		top: 140px;
		height: calc(100% - 140px);
		.turizmi-bg {
			max-width: 100%;
			// width: 100%;
			object-fit: cover;
			height: 100%;
		}
	}
	.dashboard-items {
		z-index: 3;
		margin-top: auto;
		margin-bottom: var(--bottom);
		color: white;

		.dashboard-draggable-button {
			// background-color: black;
			height: 403px;
		}
		.dashboard-arrow {
			display: flex;
			justify-content: center;
			flex-direction: column;
			align-items: center;
			.v-icon {
				animation-duration: 1.2s;
				animation-iteration-count: infinite;
			}
			.swipe-text {
				font-size: 10px;
				margin-bottom: 5px;
				margin-top: -5px;
				text-shadow: 0 0 15px black;
			}
		}
		.dashboard-items-top-wrapper {
			display: flex;
			justify-content: space-between;
			margin: 5px;
			padding: 5px;
			.dashboard-item-top {
				height: 50px;
				background-color: rgba(0, 0, 0, 0.4);
				width: 100%;
				margin: 5px;
				border-radius: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 12px;
				font-weight: 700;
				&:last-child {
					border: 3px white dashed;
					border-image-width: 8px;
				}
			}
			.dashboard-item-temp {
				.cloudy-img {
					padding-right: 4px;
					width: 35px;
				}
				.dashboard-item-temp-nr {
					display: flex;
					flex-direction: column;
				}
			}
			.dashboard-item-air {
				.wave-img {
					padding-right: 4px;
					width: 30px;
				}
			}
			.dashboard-item-notification {
				position: relative;
				.badge {
					position: absolute;
					top: -10px;
					right: -10px;
					border-radius: 50%;
					padding: 5px 10px;
					background-color: red;
					color: white;
				}
			}
			.dashboard-item-raporto {
				flex-direction: column;
			}
		}
		.dashboard-items-bottom-wrapper {
			display: flex;
			justify-content: space-between;
			padding: 0 15px 0px 15px;
			.dashboard-item-bottom {
				height: 50px;
				border-radius: 10px;
				display: flex;
				flex: 1;
				//justify-content: space-between;
				align-items: center;
				font-size: 13px;
				font-weight: 500;
				background-color: rgba(0, 0, 0, 0.4);
				padding: 8px 10px;
				&:first-child {
					margin-right: 5px;
				}
				&:last-child {
					margin-left: 5px;
				}
			}
		}
	}
}

.bounce-1 {
	animation-name: bounce-1;
	animation-timing-function: linear;
}
@keyframes bounce-1 {
	0% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-5px);
	}
	100% {
		transform: translateY(0);
	}
}

.float-button-draggable {
	position: absolute;
	top: 40%;
	right: 10px;
	background-color: #e60000;
	border-radius: 100%;
	box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.1);
	&:focus {
		outline: none;
	}
	.v-icon {
		font-size: 18px;
		margin: 8px;
	}
}
</style>
